export default function handleFormatPhoneNumber(
  phoneNumber: string | undefined,
): string {
  if (!phoneNumber) return '-';
  if (phoneNumber.includes('(')) return phoneNumber;
  return `(${phoneNumber.charAt(0)}${phoneNumber.charAt(
    1,
  )}) ${phoneNumber.substr(2, 5)}-${phoneNumber.substr(7, 4)}`;
}
